export default {
  getTrainings: (state) => state.trainingTypes
}
